<template>
  <div>
    <h2 class="text-lg font-semibold text-gray-700 ">
        Listado de nota de crédito ventas
    </h2>
    <MainCreditNoteSale />
  </div>
</template>

<script>
import MainCreditNoteSale from "@/components/Sales/CreditNote/MainCreditNoteSale.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "CreditNote",
  components: {
    MainCreditNoteSale,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
